import Carousel from "./Carousel";

export { default as CarouselFragment } from "./CarouselFragment.gql";
export default Carousel;
